// Front/src/context/LanguageContext.js

import { createContext, useContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState("he"); // default to Hebrew

  // Memoize the value to avoid unnecessary re-renders
  const value = useMemo(() => ({ language, setLanguage }), [language]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

LanguageProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useLanguageContext = () => useContext(LanguageContext);
